/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_Make_PrimaryInputs */

const cs_clients_roles_make_primary = /** @type {(inputs: Clients_Roles_Make_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit jako primární`)
};

const en_clients_roles_make_primary = /** @type {(inputs: Clients_Roles_Make_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make primary`)
};

/**
* | output |
* | --- |
* | "Make primary" |
*
* @param {Clients_Roles_Make_PrimaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_make_primary = /** @type {((inputs?: Clients_Roles_Make_PrimaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_Make_PrimaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_make_primary(inputs)
	return cs_clients_roles_make_primary(inputs)
});